import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Cookies from "universal-cookie";
import Login from "../Login/Login";
import Dashboard from "../Dashboard/Dashboard";
import NotFound from "../NotFound/NotFound";
import AddBorderConnect from "../BorderConnect/AddBorderConnect";
import { APP_URLS } from "../constants/urlConstants";
import ManageCardRoutes from "./routes/manageCardRoutes";
import TransactionRoutes from "./routes/transactionRoutes";
import UserRoutes from "./routes/userRoutes";
import ComapnyRoutes from "./routes/companyRoutes";
import InvoiceRoutes from "./routes/invoicesRoutes";
import ReportingRoutes from "./routes/reportingRoutes";
import SmartBuyRoutes from "./routes/smartbuyRoutes";
import TruckCareRoutes from "./routes/truckcareRoutes";
import Profile from "../Profile/Profile";
import ForgetPassword from "../components/ForgetPassword";
import ProfileRoutes from "./routes/profileRoute";
import DailyRatesRoutes from "./routes/dailyRatesRoute";
import CustomerRoutes from "./routes/customerRoute";
import CustomerMarkupRoutes from "./routes/customerMarkupRoutes";
import ResetPassword from "../components/ResetPassword";
import ForgotPasswordReset from "../components/ForgotPasswordReset";

const cookies = new Cookies();
const PrivateRoute = ({ component: Comp, render: renderFn, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      cookies.get("authorization")
        ? renderFn ? renderFn(props) : <Comp {...props} />
        : <Redirect to="/" />
    }
  />
);

class Routing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      access: JSON.parse(localStorage.getItem("menuAccess")),
    };
  }

  Update = () => {
    this.props.switchHeader();
  };
  renderManageCardRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.MANAGECARDS.HOME}
      render={(routeProps) => (
        <ManageCardRoutes {...routeProps} access={access?.managecardMenu} />
      )}
    />
  );
  renderTransactionRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.TRANSACTIONS.HOME}
      render={(routeProps) => (
        <TransactionRoutes {...routeProps} access={access?.transactionMenu} />
      )}
    />
  );
  // renderCompanyRoutes = (access) => (
  //   <Route
  //     path={APP_URLS.COMPANY.HOME}
  //     render={(routeProps) => (
  //       <ComapnyRoutes {...routeProps} access={access.companyMenu} />
  //     )}
  //   />
  // );
  renderCustomerRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.CUSTOMER.HOME}
      render={(routeProps) => (
        <CustomerRoutes {...routeProps} access={access.customerMenu} />
      )}
    />
  );
  renderCustomerMarkupRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.CUSTOMERMARKUP.HOME}
      render={(routeProps) => (
        <CustomerMarkupRoutes {...routeProps} access={access.markupMenu} />
      )}
    />
  );
  renderReportingRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.REPORTING.HOME}
      render={(routeProps) => (
        <ReportingRoutes {...routeProps} access={access.reportingMenu} />
      )}
    />
  );
  renderSmartBuyRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.SMARTBUY.HOME}
      render={(routeProps) => (
        <SmartBuyRoutes {...routeProps} access={access.smartbuyMenu} />
      )}
    />
  );
  renderTruckCareRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.TRUCKCARE.HOME}
      render={(routeProps) => (
        <TruckCareRoutes {...routeProps} access={access?.truckcareMenu} />
      )}
    />
  );
  renderUserRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.USERS.HOME}
      render={(routeProps) => (
        <UserRoutes {...routeProps} access={access.userMenu} />
      )}
    />
  );

  renderInvoiceRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.INVOICES.HOME}
      render={(routeProps) => (
        <InvoiceRoutes {...routeProps} access={access.invoiceMenu} />
      )}
    />
  );
  renderProfileRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.USER_PROFILE.HOME}
      render={(routeProps) => (
        <ProfileRoutes {...routeProps} access={access.userprofileMenu} />
      )}
    />
  );

  renderDailyRatesRoutes = (access) => (
    <PrivateRoute
      path={APP_URLS.DAILYRATES.HOME}
      render={(routeProps) => (
        <DailyRatesRoutes {...routeProps} access={access.dailyRatesMenu} />
      )}
    />
  );
  


  render() {
    const { access } = this.state;
    
    return (
      <Switch>
        <Route exact path="/" render={() => <Login callBack={this.Update} />} />
        <PrivateRoute path="/Dashboard" component={Dashboard} />
        <Route path="/forgot-password" component={ForgetPassword} />
        <Route path="/forgot-password-reset" component={ForgotPasswordReset} />
        <Route path="/reset-password" component={ResetPassword} />
        {this.renderManageCardRoutes(access)}
        {this.renderTransactionRoutes(access)}
        {this.renderInvoiceRoutes(access)}
        {this.renderUserRoutes(access)}
        {/* {this.renderCompanyRoutes(access)} */}
        {this.renderCustomerRoutes(access)}
        {this.renderCustomerMarkupRoutes(access)}
        {this.renderReportingRoutes(access)}
        {this.renderSmartBuyRoutes(access)}
        {this.renderTruckCareRoutes(access)}
        {this.renderProfileRoutes(access)}
        {this.renderDailyRatesRoutes(access)}
        {/* <Route path={APP_URLS.TRANSACTIONS.ADD_TRANSACTION} component={CreateTransactions}  isEdit={true}/> */}
        {/* <Route path={APP_URLS.TRANSACTIONS.HOME} component={TransactionRoutes} />
         <Route path={APP_URLS.MANAGECARDS.ADD_MANAGECARDS} component={CreateManageCards}  isEdit={true}/> 
        <Route path={APP_URLS.MANAGECARDS.HOME} component={ManageCardRoutes} />
        <Route path={APP_URLS.USERS.HOME} component={UserRoutes} />
        <Route path="/BorderConnect/" component={AddBorderConnect} /> 
        */}
        <Route path="/Profile" component={Profile} />
        <Route path="*" render={() => <NotFound />} />
      </Switch>
    );
  }
}

export default Routing;
